// Downloads a zip of an analysis's charts as PNG images. The pdf_source page is
// loaded in an off-screen iframe with ?charts_zip=1, where the calculator pack
// captures the Highcharts charts and posts the zip blob back to this page
// (see helpers/application/charts_zip_export.js).

import slug from '../helpers/application/slug';

const EXPORT_TIMEOUT_MS = 60000;

// e.g. acme-corp-security-roi-a1b2c3d4-2026-07-16.zip
const buildZipFilename = ({ prospectName, calculatorName, sessionId, date }) => {
  const parts = [slug(prospectName), slug(calculatorName), slug(sessionId).slice(0, 8), date].filter(Boolean);
  return `${parts.join('-') || 'charts'}.zip`;
};

const withChartsZipParam = (url) => `${url}${url.includes('?') ? '&' : '?'}charts_zip=1`;

const downloadBlob = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
};

let exportInProgress = false;

$(() => {
  $('.charts-zip-link').click(function(e) {
    e.preventDefault();
    if (exportInProgress) return;
    exportInProgress = true;

    const $icon = $(this).find('i');
    $icon.removeClass('fa-download').addClass('fa-spinner fa-spin');

    const prospectName = $(this).data('prospect-name');
    const calculatorName = $(this).data('calculator-name');
    const sessionId = String($(this).data('session-id') || '');
    const iframe = document.createElement('iframe');
    iframe.src = withChartsZipParam($(this).data('pdf-source-url'));
    iframe.setAttribute('aria-hidden', 'true');
    // Off-screen but laid out at a real size, so Highcharts renders the charts properly
    iframe.style.cssText = 'position:absolute;left:-10000px;top:0;width:1200px;height:2000px;border:0;';

    let timeoutId;

    const cleanup = () => {
      clearTimeout(timeoutId);
      window.removeEventListener('message', onMessage); // eslint-disable-line no-use-before-define
      iframe.remove();
      $icon.removeClass('fa-spinner fa-spin').addClass('fa-download');
      exportInProgress = false;
    };

    const fail = () => {
      cleanup();
      alert('Failed to generate chart images. Please try again later.'); // eslint-disable-line no-undef, no-alert
    };

    const onMessage = (event) => {
      if (event.origin !== window.location.origin) return;
      if (event.source !== iframe.contentWindow) return;
      if (!event.data || event.data.source !== 'hobson-charts-zip') return;

      if (event.data.status === 'done') {
        const date = new Date().toISOString().slice(0, 10);
        downloadBlob(event.data.blob, buildZipFilename({ prospectName, calculatorName, sessionId, date }));
        cleanup();
      } else {
        fail();
      }
    };

    window.addEventListener('message', onMessage);
    timeoutId = setTimeout(fail, EXPORT_TIMEOUT_MS);
    document.body.appendChild(iframe);
  });
});
